/** The tabs of editing a person (`?tab=`); HR edits Overview, Contact and HR info, the person their own skills. */
export const EDIT_TABS = {
  OVERVIEW: 'overview',
  CONTACT: 'contact',
  SKILLS: 'skills',
  HR: 'hr',
} as const;
export type EditTab = (typeof EDIT_TABS)[keyof typeof EDIT_TABS];

/** The tabs of an employee's details page (`?tab=`). */
export const EMPLOYEE_DETAIL_TABS = {
  OVERVIEW: 'overview',
  ATTENDANCE: 'attendance',
  LEAVE: 'leave',
  SKILLS: 'skills',
} as const;
export type EmployeeDetailTab = (typeof EMPLOYEE_DETAIL_TABS)[keyof typeof EMPLOYEE_DETAIL_TABS];

/** The tabs of My Profile (`?tab=`). */
export const MY_PROFILE_TABS = {
  OVERVIEW: 'overview',
  CONTACT: 'contact',
  HR: 'hr',
} as const;
export type MyProfileTab = (typeof MY_PROFILE_TABS)[keyof typeof MY_PROFILE_TABS];
